export default __webpack_public_path__ + "static/Chris_Beley_Resume_3-3-23-eac3b74973cc917cf8508c6b423815cf.pdf";